import { usePostProbeApi, usePutProbeApi } from 'api/probe'
import { Flex } from 'components/shared/flex'
import { BooleanRadioField, InputField } from 'components/shared/input'
import { GlobalStateContext } from 'contexts/global_state_context'
import { useContext, useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { Form, useEffectSkipFirst, useForm } from 'utils/hooks'
import { ApiError } from 'utils/network/api_hooks'
import { Probe, ProbeForm } from 'entities/probe'

const FormView = (form: Form<ProbeForm>, apiError: ApiError) => {
    return (
        <>
            <Flex>
                <InputField apiError={apiError} form={form} attr={'name'} label="Name" required />
            </Flex>
            <Flex>
                <InputField apiError={apiError} form={form} attr={'box'} label="Box" />
                <InputField apiError={apiError} form={form} attr={'assayId'} label="AssayID" />
            </Flex>
            <Flex>
                <InputField apiError={apiError} form={form} attr={'accessionNumber'} label="AccessionNumber" />
                <InputField apiError={apiError} form={form} attr={'sequence'} label="Sequence" />
            </Flex>
            <BooleanRadioField apiError={apiError} form={form} attr={'isActive'} positiveLabel="acitve" negativeLabel='not active' label='Status' />
            {/* <InputField apiError={apiError} form={form} attr={'original'} label="Original" required /> */}

            {/* <Flex flexWrap="wrap" style={{ marginBottom: 10 }}>
                {form.object?.tags?.map((tag) => {
                    return (
                        <Badge style={{ minWidth: 60 }} key={tag.id} bg={'secondary'}>
                            {tag.name}
                        </Badge>
                    )
                })}
            </Flex> */}
            {/* <SelectTagModal
                openButtonText="タグを選択"
                executeButtonText="追加"
                onClick={(tags: Tag[]) => {
                    form.updateObject('tags', tags)
                }}
                initialItems={form.object.tags}
            /> */}
        </>
    )
}

type NewProbeFormProps = {
    onComplete?: () => void
}

export const NewProbeForm = (props: NewProbeFormProps): JSX.Element => {
    const globalState = useContext(GlobalStateContext)
    const api = usePostProbeApi()
    const form = useForm<ProbeForm>({})
    const [show, setShow] = useState<boolean>(false)

    const handleUpdate = () => {
        api.execute(form)
    }

    useEffectSkipFirst(() => {
        globalState.setLoading(api.loading)
        if (api.isSuccess()) {
            if (props.onComplete) {
                setShow(false)
                props.onComplete()
            }
        }
    }, [api.loading])

    const handleClose = () => {
        setShow(false)
    }

    return (
        <>
            <Button
                variant="success"
                onClick={() => {
                    setShow(true)
                }}
            >
                新規登録
            </Button>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Probeの登録</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <>{FormView(form, api.apiError)}</>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        閉じる
                    </Button>
                    <Button variant="success" onClick={handleUpdate}>
                        登録
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

type EditProbeFormProps = {
    probe: Probe
    show: boolean
    onClose: () => void
    onComplete?: () => void
}

export const EditProbeForm = (props: EditProbeFormProps): JSX.Element => {
    const globalState = useContext(GlobalStateContext)
    const api = usePutProbeApi()
    const form = useForm<ProbeForm>({ ...props.probe })

    useEffectSkipFirst(() => {
        form.set(props.probe)
    }, [props.probe])

    const handleUpdate = () => {
        api.execute(form)
    }

    useEffectSkipFirst(() => {
        globalState.setLoading(api.loading)
        if (api.isSuccess()) {
            if (props.onComplete) {
                props.onComplete()
            }
        }
    }, [api.loading])

    return (
        <Modal show={props.show} onHide={props.onClose}>
            <Modal.Header closeButton>
                <Modal.Title>Probeの編集</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {form.object.id && (
                    <>
                        <h3 style={{ marginBottom: 10 }}>{props.probe.name}</h3>
                        {FormView(form, api.apiError)}
                    </>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={props.onClose}>
                    閉じる
                </Button>
                <Button variant="success" onClick={handleUpdate}>
                    更新
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
